'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDefaultFilterValue = getDefaultFilterValue;
exports.getValidOperators = getValidOperators;
exports.getGenericFieldType = getGenericFieldType;
exports.generateId = generateId;

var _v = require('uuid/v1');

var _v2 = _interopRequireDefault(_v);

var _operators = require('../defaults/operators');

var _operators2 = _interopRequireDefault(_operators);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getDefaultFilterValue(field) {
  if (field.domain && field.domain.codedValues) {
    return field.domain.codedValues[0];
  }

  return { name: '', code: '' };
}

function getValidOperators(fieldType) {
  var operators = _operators2.default[getGenericFieldType(fieldType)];

  return operators || [];
}

function getGenericFieldType(fieldType) {
  // REST API Field Types
  // strings: 'esriFieldTypeString',
  // dates: 'esriFieldTypeDate',
  // numbers: ['esriFieldTypeOID',
  //           'esriFieldTypeSmallInteger',
  //           'esriFieldTypeInteger',
  //           'esriFieldTypeSingle',
  //           'esriFieldTypeDouble'],

  // JSAPI Field Types
  //small-integer | integer | single | double | long | string | date | oid | geometry | blob | raster | guid | global-id | xml

  switch (fieldType) {
    case null:
      return null;

    case 'esriFieldTypeString':
    case 'esriFieldTypeGUID':
    case 'oid':
    case 'guid':
    case 'global-id':
    case 'string':
      return 'string';

    case 'esriFieldTypeOID':
    case 'esriFieldTypeSmallInteger':
    case 'esriFieldTypeInteger':
    case 'esriFieldTypeSingle':
    case 'esriFieldTypeDouble':
    case 'small-integer':
    case 'integer':
    case 'single':
    case 'double':
    case 'long':
      return 'number';

    case 'esriFieldTypeDate':
    case 'date':
      return 'date';

    case 'epoch':
      return 'epoch';

    default:
      console.warn('Invalid field type! Defaulting to string.', fieldType);
      return 'string';
  }
}

function generateId() {
  return (0, _v2.default)();
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/arcgis-filter/dist/utils/genericUtils.js
// module id = 246
// module chunks = 0